export default () => window.dispatchEvent(new Event('scroll'));
